import React from 'react';
import { displayName } from '../../../../App';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/AccountManagement/CreateUser';
import AccountManagementProvider from '../../../context/accountManagement';

function AccountManagementCreateUser() {
  document.title = `${displayName}: Account Management: Create User`;

  return (
    <MainInfoTracLayout className="min-h-screen">
      <AccountManagementProvider>
        <Content />
      </AccountManagementProvider>
    </MainInfoTracLayout>
  );
}

export default AccountManagementCreateUser;
